import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourSeguridadOrganizaciones: TourDefinicion = {
  codigo: 'seguridad-organizaciones',
  titulo: 'Organizaciones',
  descripcion: 'Tenants/organizaciones del portal.',
  ruta: '/admin/seguridad/organizaciones',
  permisoMenu: Permisos.ORGANIZACIONES_MENU,
  pasos: [
    {
      id: 'seguridad-organizaciones:header',
      selector: '[data-testid="seguridad-organizaciones.header"]',
      titulo: 'Organizaciones',
      descripcion:
        'Las organizaciones agrupan usuarios, roles y datos. Un usuario puede pertenecer a varias organizaciones.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'seguridad-organizaciones:boton-crear',
      selector: '[data-testid="seguridad-organizaciones.boton-crear"]',
      titulo: 'Nueva organización',
      descripcion:
        'Registra una organización nueva con su código y nombre. Los datos que se creen luego quedan aislados por organización.',
      permisoRequerido: Permisos.ORGANIZACIONES_CREAR,
      side: 'left',
      align: 'center',
    },
    {
      id: 'seguridad-organizaciones:tabla',
      selector: '[data-testid="seguridad-organizaciones.tabla"]',
      titulo: 'Listado',
      descripcion: 'Edita el nombre o desactiva una organización desde las acciones de la fila.',
      side: 'top',
      align: 'center',
    },
  ],
};
